<template>
  <div class="bind-wechat-wrapper">
    
    <!-- 非微信浏览器：隐藏页面所有内容，只提示在微信中打开 -->
    <div class="page-tip" v-if="!isWechat">
      <van-icon name="wechat" class="page-tip-icon wechat-icon" />
      <p>请在微信浏览器中打开</p>
    </div>
    
    <!-- 绑定成功：隐藏页面所有内容，只提示关闭页面 -->
    <div class="page-tip" v-else-if="bindSuccess">
      <van-icon name="checked" class="page-tip-icon success-icon" />
      <p>绑定成功，请关闭该页面</p>
    </div>
    <template v-else>
      <div class="scroll-view">
        <div class="flex-cover top">
          <div class="logo" v-if="logoShow">
            <img :src="logoShow | $imageUrl" :alt="systemName" />
          </div>
          <div class="title">
            <p :style="{ background: mainColor }">{{ systemName }}微信绑定</p>
          </div>
        </div>
        <div class="bind-form">
          <div class="tips">
            请填写需要绑定微信的会员手机号，并输入短信验证码完成绑定。
          </div>
          <van-field
            v-model="phone"
            name="phone"
            type="tel"
            maxlength="11"
            placeholder="请填写手机号码"
            autocomplete="off"
            ref="phoneFocus"
            @keydown.enter.native="bindConfirm"
          >
            <template #left-icon>
              <van-icon name="system-username" class="bind-icon" />
            </template>
            <template #right-icon>
              <!-- vant 原生 clearable 只监听 touchstart（鼠标点不动），这里自定义一个可点击的清除按钮 -->
              <van-icon
                name="clear"
                class="bind-clear-icon"
                v-if="phone"
                @click.stop="clearPhone"
              />
            </template>
          </van-field>
          <van-field
            v-model="phoneCode"
            center
            maxlength="6"
            ref="codeFocus"
            placeholder="短信验证码"
            @keydown.enter.native="bindConfirm"
          >
            <template #left-icon>
              <van-icon name="system-yanzhengma2-01" class="bind-icon base" />
            </template>
            <template #button>
              <van-button
                size="mini"
                type="info"
                :disabled="true"
                v-if="countdown"
                >{{ num }}秒后可重新获取</van-button
              >
              <van-button
                type="info"
                size="mini"
                @click="codeStart"
                :disabled="loading || !wxCode"
                v-else
                >{{ isInit ? "重新获取" : "获取验证码" }}</van-button
              >
            </template>
          </van-field>
          <div class="bind-btn" @click="bindConfirm" :style="btnColor">
            绑 定
          </div>
          <div class="auth-tips" v-if="authError">
            <van-icon name="warning" />
            <span
              >微信授权失败，必须完成微信授权后才能获取手机号并绑定，请点击下方「重新获取微信授权」重试。</span
            >
          </div>
          <!-- 只有授权失败时才提供重新授权入口 -->
          <div class="toolbar" v-if="authError">
            <div class="item" @click="wechatAuth">重新获取微信授权</div>
          </div>
        </div>
      </div>
      <verify-code
        v-model="verifyCodeShow"
        @confirm="getCheckCode"
        ref="verifyCode"
        :loading="codeLoading"
      ></verify-code>
    </template>
  </div>
</template>

<script>
import verifyCode from "@/components/common/verify-code";
import sessionStorage from "@/utils/sessionStorage";
import api from "@/api";
import { isPhone, isWeex } from "@/utils";

//微信授权跳转标记的有效期（与微信 code 5 分钟有效期保持一致）
const WX_AUTH_FLAG_TIMEOUT = 5 * 60 * 1000;
export default {
  components: {
    verifyCode,
  },
  data() {
    return {
      //微信网页授权 code，由微信 302 回调带回，一次性有效
      wxCode: "",

      //防止重复发起微信授权跳转
      wxAuthLoading: false,

      //微信授权失败提示（展示在绑定按钮下方）
      authError: false,

      //是否绑定成功（成功后隐藏其他内容，只展示成功提示）
      bindSuccess: false,

      //会员手机号
      phone: "",

      //短信验证码
      phoneCode: "",

      logoHm: require("@/assets/images/login_logo_hm.png"),

      logo: require("@/assets/images/login_logo.png"),

      verifyCodeShow: false,
      //是否在倒计时
      countdown: false,
      //倒计时秒数
      countdownSecond: 60,
      num: 0,
      inv_id: null,
      loading: false,
      isInit: false,
      status: "codeStart",
      codeLoading: false,
    };
  },
  computed: {
    btnColor() {
      const mainColor = this.mainColor || "#00a0e4";
      const gradientColor = this.gradientColor || mainColor;
      return {
        "background-color": mainColor,
        "background-image": `linear-gradient(to right, ${mainColor}, ${gradientColor})`,
      };
    },
    mainColor() {
      return this.$store.state.userInfo?.company?.color;
    },
    gradientColor() {
      return this.$store.state.userInfo?.company?.gradientColor;
    },

    logoShow() {
      return this.$store.state.userInfo?.company?.logo;
    },

    systemName() {
      return this.$store.state.userInfo?.company?.title;
    },

    //是否为微信浏览器
    isWechat() {
      return isWeex();
    },
  },
  methods: {
    //跳转微信网页授权，获取 code（参考 authorization.vue 的 wechatLogin）
    wechatAuth() {
      if (this.wxAuthLoading) {
        return;
      }
      this.wxAuthLoading = true;

      //重新授权前先清掉上一次的失败提示
      this.authError = false;

      this.$toast.loading({
        message: "正在获取授权...",
        duration: 0,
        forbidClick: true,
      });

      api.wxCode({
        options: {
          url: "https://" + window.location.host + this.$route.path,
        },

        success: (res) => {
          if (res.type == 200 && res.data) {
            //标记已发起授权，用于识别「从微信授权返回但没有 code」的授权失败
            sessionStorage.StorageSetter("bindWechatAuthorizing", Date.now());

            window.location.href = res.data;
          } else {
            this.wxAuthLoading = false;

            //授权失败：在绑定按钮下方常驻提示，引导用户重新授权
            this.authError = true;
          }
        },

        error: (err) => {
          console.log(err);

          this.wxAuthLoading = false;

          //授权失败：在绑定按钮下方常驻提示，引导用户重新授权
          this.authError = true;
        },

        complete: () => {
          this.$toast.clear();
        },
      });
    },
    //处理微信授权回调带回的 code
    getWxCode() {
      //非微信浏览器不处理授权
      if (!this.isWechat) {
        return;
      }

      //是否刚发起过微信授权跳转（超过有效期视为残留标记）
      const authorizingAt = sessionStorage.StorageGetter(
        "bindWechatAuthorizing"
      );

      const authorizing =
        authorizingAt && Date.now() - authorizingAt < WX_AUTH_FLAG_TIMEOUT;

      if (this.$route.query.code) {
        //授权成功，缓存 code 供绑定接口使用（code 一次性、5 分钟内有效）
        sessionStorage.StorageRemove("bindWechatAuthorizing");

        this.wxCode = this.$route.query.code;
        this.wxAuthLoading = false;
        this.authError = false;
        //拿到 code 后聚焦手机号输入框
        this.$nextTick(() => {
          this.$refs.phoneFocus?.focus();
        });
      } else if (authorizing) {
        //已发起授权却空手返回：用户取消授权或微信侧授权失败
        sessionStorage.StorageRemove("bindWechatAuthorizing");

        this.wxAuthLoading = false;
        this.authError = true;
      } else if (!this.wxCode) {
        //地址上没有 code，进入页面立即跳转微信授权
        this.wechatAuth();
      }
    },
    //清空手机号（vant 原生 clearable 只监听 touchstart，鼠标点击无效，这里自定义）
    clearPhone() {
      this.phone = "";
    },
    //获取短信验证码前的校验
    codeStart() {
      if (!this.phone) {
        this.$toast({
          position: "bottom",
          message: "手机号不能为空",
        });
        this.$refs.phoneFocus.focus();
        return;
      }
      if (!isPhone(this.phone)) {
        this.$toast({
          position: "bottom",
          message: "手机号格式不正确",
        });
        this.$refs.phoneFocus.focus();
        return;
      }
      //每次获取都拉起机器验证码
      this.verifyCodeShow = true;
    },
    getCheckCode(verifyCode) {
      this.loading = true;
      this.codeLoading = true;
      api.getCode({
        options: {
          username: this.phone,
          ...verifyCode,
        },
        success: (res) => {
          if (res.type == 200) {
            this.verifyCodeShow = false;
            this.$toast({
              message: "已成功发送验证码",
              position: "bottom",
            });
            this.countdownStart();
            this.isInit = true;
            this.status = "checkCode";
            //聚焦
            this.$nextTick(() => {
              this.$refs.codeFocus.focus();
            });
          } else {
            this.$toast(res.msg);
            this.$refs.verifyCode?.getVerifyCode &&
              this.$refs.verifyCode?.getVerifyCode();
          }
        },
        error: (err) => {
          console.log(err);
          this.$refs.verifyCode?.getVerifyCode &&
            this.$refs.verifyCode?.getVerifyCode();
        },
        complete: () => {
          this.loading = false;
          this.codeLoading = false;
        },
      });
    },
    //开始倒计时
    countdownStart() {
      //开始倒计时
      this.countdown = true;
      this.num = this.countdownSecond;
      this.num--;
      this.inv_id = setInterval(() => {
        this.num--;
        if (!this.num) {
          this.countdown = false;
          clearInterval(this.inv_id);
        }
      }, 1000);
    },
    //停止倒计时
    countdownEnd() {
      clearInterval(this.inv_id);
      this.countdown = false;
      this.num = 0;
    },
    //回车：先获取验证码，再提交绑定
    bindConfirm() {
      if (this.status == "codeStart") {
        this.codeStart();
      } else {
        this.bind();
      }
    },
    //绑定微信
    bind() {
      if (!this.wxCode) {
        this.$toast({
          position: "bottom",
          message: "微信授权中，请稍候",
        });
        this.wechatAuth();
        return;
      }
      if (!this.phone) {
        this.$toast({
          position: "bottom",
          message: "手机号不能为空",
        });
        this.$refs.phoneFocus.focus();
        return;
      }
      if (!isPhone(this.phone)) {
        this.$toast({
          position: "bottom",
          message: "手机号格式不正确",
        });
        this.$refs.phoneFocus.focus();
        return;
      }
      if (!this.phoneCode) {
        this.$toast({
          position: "bottom",
          message: "验证码不能为空",
        });
        this.$refs.codeFocus.focus();
        return;
      }
      this.$toast.loading({
        duration: 0,
        message: "绑定中...",
        forbidClick: true,
        cancelButtonColor: "#00a0e4",
      });
      api.bindWxByPhone({
        options: {
          code: this.wxCode,
          phone: this.phone,
          phoneCode: this.phoneCode,
        },
        success: (res) => {
          if (res.type == 200) {
            //绑定成功：隐藏表单等所有内容，只展示成功提示，由用户自行关闭页面
            this.bindSuccess = true;
            this.verifyCodeShow = false;
            this.countdownEnd();

            //已登录时同步绑定状态并刷新用户信息
            if (this.$store.state.userInfo.ready) {
              this.$store.commit("setUserData", {
                key: "bindWx",
                value: 1,
                save: true,
              });
              api.getUserInfo({
                success: () => {},
              });
            }
          } else {
            this.$dialog.alert({
              title: "绑定失败",
              message: res.msg || "微信绑定失败，请求异常，请稍后重试",
            });
          }
        },
        error: (err) => {
          console.log(err);
          this.$dialog.alert({
            title: "绑定失败",
            message: `绑定异常，请稍后重试,${err}`,
          });
        },
        complete: () => {
          this.$toast.clear();
        },
      });
    },
  },
  created() {
    //非微信浏览器只展示“请在微信浏览器中打开”，不做任何授权处理
    if (!this.isWechat) {
      return;
    }
    //进入页面立即判断是否需要跳转微信授权
    this.getWxCode();
  },
  activated() {
    //非微信浏览器不处理
    if (!this.isWechat) {
      return;
    }
    //从微信授权返回或页面被再次激活时重新判断
    this.getWxCode();
  },
  beforeDestroy() {
    this.countdownEnd();
  },
  deactivated() {
    this.countdownEnd();
  },
};
</script>

<style lang="less">
.bind-wechat-wrapper {
  height: 100%;

  .page-tip {
    height: 100%;

    display: flex;

    flex-direction: column;

    align-items: center;

    justify-content: center;

    //底部留白，让居中内容整体略微上移
    padding: 0 30px 100px;

    text-align: center;

    .page-tip-icon {
      font-size: 80px;
    }

    .wechat-icon {
      color: #46bb36;
    }

    .success-icon {
      color: #009eed;
    }

    p {
      padding-top: 20px;

      font-size: 18px;

      color: #777777;
    }
  }

  .scroll-view {
    height: 100%;

    overflow: hidden;

    overflow-y: scroll;

    padding-bottom: 30px;
  }

  .top {
    display: flex;

    flex-direction: column;

    justify-content: center;

    align-items: center;

    min-height: 30vh;
  }

  .logo {
    width: 200px;

    height: 200px;

    position: relative;

    left: -5px;

    img {
      width: 100%;

      height: 100%;
    }
  }

  .title {
    text-align: center;

    p {
      display: inline-block;

      padding: 6px 20px;

      font-size: 16px;

      color: #ffffff;

      border-radius: 25px;
    }
  }

  .bind-form {
    padding: 0 30px;
    margin-top: 30px;

    .tips {
      font-size: 13px;

      color: #999999;

      line-height: 20px;

      padding-bottom: 10px;
    }
  }

  .bind-btn {
    height: 40px;

    line-height: 40px;

    text-align: center;

    font-size: 20px;

    color: #ffffff;
    border-radius: 25px;

    margin-top: 30px;

    transition: opacity 0.3s ease;

    &:active {
      opacity: 0.6;
    }
  }

  .bind-icon {
    font-size: 22px;

    margin-right: 10px;

    &.base {
      font-size: 30px;
      margin-right: 3px;
      position: relative;
      left: -4px;
    }
  }

  .bind-clear-icon {
    //与原生 clear 图标视觉一致，但支持鼠标点击
    color: #c8c9cc;

    cursor: pointer;

    &:active {
      color: #969799;
    }
  }

  .van-cell {
    font-size: 16px;

    .van-field__control {
      padding-top: 3px;
    }
  }

  .toolbar {
    display: flex;

    justify-content: center;

    padding-top: 15px;

    .item {
      font-size: 13px;

      color: #00a0e4;

      padding: 0 10px;

      opacity: 0.8;
    }
  }
}
</style>
